/**
 * useWorkStatusFilters Hook
 * 라이더 근무 현황 필터 상태 관리
 */
import { useState, useCallback } from 'react';
import { RiderWorkStatusFilters } from '../types/riderWorkStatus.types';
import { formatDateToStorage } from '../utils/dateFormatters';
import { DEFAULT_DATE_RANGE_DAYS } from '../constants/riderWorkStatus.constants';
import { getItem } from '@/shared/utils/storage';

/**
 * 기본 필터 생성 (오늘 기준 N일 전 ~ 오늘)
 */
export const createDefaultFilters = (): RiderWorkStatusFilters => {
    const today = new Date();
    const startDate = new Date();
    startDate.setDate(today.getDate() - DEFAULT_DATE_RANGE_DAYS);

    return {
        fromDate: formatDateToStorage(startDate),
        toDate: formatDateToStorage(today),
    };
};

export const useWorkStatusFilters = () => {
    const [filters, setFilters] = useState<RiderWorkStatusFilters>(() => createDefaultFilters());

    const userType = getItem<string>('USER_TYPE');
    const isSupplierUser = userType === 'SUPPLIER';

    /**
     * 필터 변경 핸들러
     */
    const handleFilterChange = useCallback((key: keyof RiderWorkStatusFilters, value: string) => {
        setFilters((prev: RiderWorkStatusFilters) => ({ ...prev, [key]: value }));
    }, []);

    return {
        filters,
        isSupplierUser,
        handleFilterChange,
    };
};
